import { styled } from 'baseui'

export const Grid = styled('div', {
  display: 'grid',
  gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  gap: '1rem',
  alignItems: 'stretch',
  '@media screen and (max-width: 1100px)': {
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
  },
  '@media screen and (max-width: 700px)': {
    gridTemplateColumns: 'minmax(0, 1fr)',
  },
})

export const EmptyState = styled('div', ({ $theme }) => ({
  padding: '1.5rem',
  textAlign: 'center',
  borderRadius: $theme.borders.radius400,
  borderWidth: '1px',
  borderStyle: 'dashed',
  borderColor: $theme.colors.borderMedium,
  color: $theme.colors.textMuted,
  ...$theme.typography.ParagraphSmall,
}))
